export default "__VITE_ASSET__KFjUVlsS__"